<template>
    <div class="header">
        <van-nav-bar
            safe-area-inset-top
            :title='this.$route.meta.title'
            @click-left="onClickLeft"
        >
          <template #left v-if="this.$route.meta.iconLeft">
            <van-icon name="arrow-left" class="font" />
          </template>
          <template #right>

          </template>
        </van-nav-bar>
    </div>
</template>
<script>
import {getLocalItem} from "@/untils/common";

export default {
    name:'',
    data(){
        return{

        }
    },
    methods:{
        onClickLeft(){
            let tit = this.$route.meta.title;
            if(tit!=='首页'){
              // this.$router.go(-1);
              this.$router.push({path: '/userHome',query:{openid: getLocalItem('open_id')}})
            }
        },
    },
    created(){

    }
}
</script>
<style lang="scss" scoped>
.font{
  font-size:40px
}
.van-nav-bar{
  position: fixed;
  z-index: 10;
  top: 0;
}
</style>
